import { AccessClient } from "./axiosInstance.js";

// 모든 교수에 대한 개략적인 정보 가져오기
export const loadAllProfessors = async () => {
  try {
    const response = await AccessClient.get("/api/professors");
    //console.log("response : ", response);
    const {
      status,
      data: { data, message },
    } = response;
    return { status, data, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;

    //console.log(status);
    //console.log(message);
    return { status, message };
  }
};

// 교수에 대한 정보 가져오기
export const loadProfessor = async ({ id }) => {
  try {
    const response = await AccessClient.get(`/api/professors/${id}`);
    //console.log("response : ", response);
    const {
      status,
      data: { data, message },
    } = response;
    return { status, data, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;

    //console.log(status);
    //console.log(message);

    return { status, message };
  }
};

// 교수에 대한 정보 저장하기
export const saveProfessor = async ({ id, weekId, weekState, weekAuth }) => {
  //console.log("saveProfessor => ", id, weekId, weekState, weekAuth);

  try {
    const response = await AccessClient.put(`/api/professors/${id}`, {
      weekId,
      weekState,
      weekAuth,
    });
    const {
      status,
      data: { data, message },
    } = response;

    return { status, course: data, message };
  } catch (error) {
    const {
      status,
      data: { message },
    } = error.response;
    return { status, message };
  }
};
